<vdr-card>
  <div class="card-title">{{ 'org-hierarchy.companies' | translate }}</div>
  <vdr-data-table-2
    id="customer-employment-list"
    [items]="items$ | async"
    [itemsPerPage]="itemsPerPage$ | async"
    [totalItems]="totalItems$ | async"
    [currentPage]="currentPage$ | async"
  >
    <vdr-dt2-column
      id="id"
      [heading]="'org-hierarchy.company-id' | translate"
      [hiddenByDefault]="true"
    >
      <ng-template let-item="item"> {{ item.company.id }} </ng-template>
    </vdr-dt2-column>

    <vdr-dt2-column
      id="created-at"
      [heading]="'common.created-at' | translate"
      [hiddenByDefault]="true"
    >
      <ng-template let-item="item">
        {{ item.createdAt | localeDate : 'short' }}
      </ng-template>
    </vdr-dt2-column>

    <vdr-dt2-column
      id="updated-at"
      [heading]="'common.updated-at' | translate"
      [hiddenByDefault]="true"
    >
      <ng-template let-item="item">
        {{ item.updatedAt | localeDate : 'short' }}
      </ng-template>
    </vdr-dt2-column>

    <vdr-dt2-column
      id="company"
      [heading]="'org-hierarchy.company-name' | translate"
      [optional]="false"
    >
      <ng-template let-item="item">
        <a
          class="button-ghost"
          [routerLink]="['/extensions/companies/', item.company.id]"
        >
          <span>{{ item.company.name }}</span>
          <clr-icon shape="arrow right"></clr-icon>
        </a>
      </ng-template>
    </vdr-dt2-column>

    <vdr-dt2-column id="role" [heading]="'org-hierarchy.role' | translate">
      <ng-template let-item="item"> {{ item.role }} </ng-template>
    </vdr-dt2-column>

    <vdr-dt2-column id="state" [heading]="'org-hierarchy.state' | translate">
      <ng-template let-item="item"> {{ item.state }} </ng-template>
    </vdr-dt2-column>
  </vdr-data-table-2>
</vdr-card> 